<template>
  <div class="card__item" @mouseover="onHovered" @mouseout="onUnHovered">
    <img :src="report.image" alt="" class="card__icon" />
    <p class="card__title">{{ report.name }}</p>
    <div class="card__label" v-if="report.is_demo || report.is_packet">
      <div class="bg-yellow card__label-label" v-if="report.is_demo">
        Demo
      </div>
      <div
        class="card__label-second card__label-label"
        v-if="report.is_packet"
      >
        Personal
      </div>
    </div>
    <p class="card__text">
      {{ report.short_description | normalizeDescription }}
    </p>
    <BaseButton
      color="outline-blue"
      class="sidebar-menu__button"
      @click="onClicked"
      size="small"
      ref="cardButton"
      >Смотреть
    </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClicked() {
      if (this.report.is_demo) {
        this.$modal.show("unavailableReportForm", { id: this.report.id });
      } else {
        this.$router.push({
          name: "chartReport",
          params: {
            id: this.report.id
          }
        });
      }
    },
    getIcon(image_name) {
      return "/media/" + image_name;
    },
    onHovered() {
      this.$refs.cardButton.onMouseOver();
    },
    onUnHovered() {
      this.$refs.cardButton.onMouseOut();
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  &__item {
    display: flex;
    flex-direction: column;
    background: #f4fbff;
    border: 1px dashed #46adf4;
    box-sizing: border-box;
    border-radius: 8px;
    width: 100%;
    height: 23.3rem;
    padding: 2rem 1.6rem;
    justify-content: space-between;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    position: relative;

    &:hover {
      background: #0082be;
      border: 1px dashed #46adf4;
      border-radius: 0.8rem;

      & > .card {
        &__icon {
          filter: brightness(0) invert(1);
        }

        &__title {
          color: #ffffff;
        }

        &__text {
          color: #cce9ff;
        }
      }

      & > .button {
        background: #ffbe55;
        border: 1px solid #ffbe55;
        color: white;
      }
    }
  }

  &__list {
    margin-bottom: 10rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(256px, 1fr));
    grid-gap: 15px;
  }

  &__item {
    font-weight: 600;
    font-size: 1.4rem;
    text-align: center;
    letter-spacing: -0.02em;
    color: #005177;
  }

  &__text {
    font-size: 1.2rem;
    text-align: center;
    color: #9c9898;
  }

  &__icon {
    width: 3.8rem;
    height: 3.8rem;
    margin: 0 auto;
  }

  &__label {
    position: absolute;
    top: 3px;
    right: 2px;

    &-label {
      border-radius: 0 6px;
      padding: 4px 14px;
      color: #ffffff;
    }

    &-second {
      margin-top: 3px;
      background-color: #22c55e;
    }
  }
}

.bg-yellow {
  background: #ffbe55;
}
</style>
